import { defineModule, } from 'direct-vuex';

export interface ResetPasswordState {
	currentStep: number | null;
	resetToken: string | null;
	securityQuestion: {
		securityQuestionId: number,
		securityAnswer: string,
	} | null;
}

export default defineModule({
	namespaced: true as const,
	state: {
		securityQuestion: null,
		currentStep: null,
	} as ResetPasswordState,
	mutations: {
		setStep(state, step: number | null) {
			state.currentStep = step;
		},
		setResetToken(state, token: string | null) {
			state.resetToken = token;
		},
		setSecurityQuestion(state, securityQuestion: { securityQuestionId: number, securityAnswer: string, }) {
			state.securityQuestion = securityQuestion;
		},
		reset(state) {
			state.currentStep = null;
			state.resetToken = null;
			state.securityQuestion = null;
		},
	},
});
